import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { Send, RefreshCcw, Check, LogIn, AlertTriangle } from 'lucide-react';
import './RequestQuoteButton.less'; // Importar el archivo LESS
import { requestQuote } from '../redux/actions/orderAction';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Función para codificar en Base64
const Base64 = {
  encode: str => btoa(str),
};

export const RequestQuoteButton = ({ orderId }) => {
  //  VARIABLES: Estado local del componente
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(
    !!localStorage.getItem('userToken')
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //  SUGERENCIA: UseEffect para monitorear el estado de autenticación de localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      setIsUserLoggedIn(!!localStorage.getItem('userToken'));
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // 1. FUNCIÓN handleRequestQuote()
  const handleRequestQuote = useCallback(async () => {
    //console.log('Request Quote Button');
    if (success) return;

    //const userToken = localStorage.getItem('userToken');

    try {
      const timestamp = Date.now();
      //const tokenString = `${orderId}-${timestamp}`;
      // const requestToken = Base64.encode(tokenString);

      const payload = {
        orderId: orderId,
        // requestToken: requestToken,
        // timestamp: timestamp,
      };

      // const response = await axios.post('/order/request-quote', payload, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     Authorization: `Bearer ${userToken}`,
      //   },
      // });

      dispatch(requestQuote(orderId));

      setSuccess(true);
      // setMessage(response.data.message || 'Cotización solicitada con éxito.');
    } catch (error) {
      const apiError = error.response?.data?.error;
      console.error('API Request Error:', error);
      setSuccess(false);

      if (apiError) {
        setMessage(apiError);
      } else {
        setMessage('Error de conexión. Inténtalo de nuevo.');
      }
    } finally {
      setLoading(false);
    }
    // }, [orderId, success, isUserLoggedIn]);
  }, [orderId, success]);
  // 2. RENDERIZAR_COMPONENTE
  const buttonText = loading
    ? 'Enviando...'
    : success
    ? 'Solicitud Enviada'
    : 'Solicitar Cotización';

  const isDisabled = loading || success;

  // Determinar clases CSS según el estado
  let buttonClass = 'request-quote-button';
  let Icon = Send;
  let iconClass = 'icon';

  if (loading) {
    buttonClass += ' loading';
    Icon = RefreshCcw;
    iconClass += ' spinning';
  } else if (success) {
    buttonClass += ' success';
    Icon = Check;
  } else if (!isUserLoggedIn) {
    buttonClass += ' not-logged-in';
    Icon = LogIn;
  } else {
    buttonClass += ' default';
    Icon = Send;
  }

  return (
    <div className="request-quote-container">
      <button
        onClick={handleRequestQuote}
        disabled={isDisabled}
        className={buttonClass}
      >
        <Icon className={iconClass} />
        {buttonText}
      </button>

      {message && (
        <div
          className={`message-box ${
            success ? 'success-message' : 'error-message'
          }`}
          role="alert"
        >
          {success ? (
            <Check className="message-icon" />
          ) : (
            <AlertTriangle className="message-icon" />
          )}
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};
